import React from "react";

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="none"
      aria-labelledby="logoTitle"
      role="img"
      className={className}
    >
      <title id="logoTitle">SevenServings logomark</title>
      {/* Circular bowl — the centre of the mark */}
      <path
        d="M190 250 C190 336 218 380 256 380 C294 380 322 336 322 250 L322 236 H190 Z"
        fill="currentColor"
      />
      {/* Seven leaves/ticks arranged around the bowl like a weekly clock */}
      <ellipse
        cx="0"
        cy="0"
        rx="15"
        ry="28"
        transform="translate(256 86) rotate(0)"
        fill="currentColor"
      />
      <ellipse
        cx="0"
        cy="0"
        rx="15"
        ry="28"
        transform="translate(388.91 150.01) rotate(51.43)"
        fill="currentColor"
      />
      <ellipse
        cx="0"
        cy="0"
        rx="15"
        ry="28"
        transform="translate(421.74 293.83) rotate(102.86)"
        fill="currentColor"
      />
      <ellipse
        cx="0"
        cy="0"
        rx="15"
        ry="28"
        transform="translate(329.76 409.16) rotate(154.29)"
        fill="currentColor"
      />
      <ellipse
        cx="0"
        cy="0"
        rx="15"
        ry="28"
        transform="translate(182.24 409.16) rotate(205.71)"
        fill="currentColor"
      />
      <ellipse
        cx="0"
        cy="0"
        rx="15"
        ry="28"
        transform="translate(90.26 293.83) rotate(257.14)"
        fill="currentColor"
      />
      <ellipse
        cx="0"
        cy="0"
        rx="15"
        ry="28"
        transform="translate(123.09 150.01) rotate(308.57)"
        fill="currentColor"
      />
    </svg>
  );
};

export default Logo;
